<template>
  <div class="login" @keydown.enter="handleSubmit">
    <div class="login-word" style="height: 100px">
      <img src="../../../static/image/login-word.png" alt="标题" srcset="" />
    </div>
    <div class="login-con">
      <Card :bordered="false">
        <p slot="title" style="text-align: center">
          <Icon type="log-in"></Icon>
          欢迎登录
        </p>
        <div class="form-con">
          <Form ref="loginForm" :model="loginModel" :rules="rules">
            <FormItem prop="mobile">
              <Input v-model="loginModel.mobile" placeholder="请输入手机号">
                <span slot="prepend">
                  <Icon type="person" :size="16"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input
                type="password"
                v-model="loginModel.password"
                placeholder="请输入密码"
              >
                <span slot="prepend">
                  <Icon :size="14" type="locked"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem>
              <Button
                @click="handleSubmit"
                type="success"
                long
                :loading="loginLoading"
                >登录</Button
              >
            </FormItem>
          </Form>
        </div>
      </Card>

      <Modal
        v-model="modalSelectHospital"
        title="请选择医院"
        @on-ok="okSelectHospital"
        @on-cancel="cancelSelectHospital"
      >
        <Select v-model="selectHospital.hospitalGuid">
          <Option
            v-for="(item, index) in selectHospital.hospitalList"
            :value="item.hospitalGuid"
            :key="index"
            >{{ item.hospitalName }}</Option
          >
        </Select>
      </Modal>

      <!-- 二维码弹框 -->
      <Modal
        v-model="modalcode"
        width="360"
        :closable="false"
        :mask-closable="false"
        :footer-hide="judge"
      >
        <p slot="header" style="color: #f60; text-align: center">
          <Icon type="ios-information-circle"></Icon>
          <span>{{ text }}</span>
        </p>
        <div style="text-align: center">
          <vue-qr ref="Qrcode" :text="codeQr" qid="testQrId"></vue-qr>
        </div>
        <div slot="footer">
          <Button type="warning" size="large" long @click="codeFn">确定</Button>
        </div>
      </Modal>
      <!-- 自动签二维码弹框 -->
      <Modal
        v-model="modalCAcode"
        width="360"
        :closable="false"
        :mask-closable="false"
        :footer-hide="true"
      >
        <p slot="header" style="color: #f60; text-align: center">
          <Icon type="ios-information-circle"></Icon>
          <span>请扫描二维码实现自动签</span>
        </p>
        <div style="text-align: center">
          <img
            v-if="
              caType == 'yiWangXinCaClient' ||
              caType == 'yiWangXinInternetCaClient'
            "
            :src="CAcode"
            alt="图片Base64编码"
            srcset=""
          />
          <vue-qr v-else ref="Qrcode" :text="CAcode" qid="testQrId"></vue-qr>
        </div>
        <!-- <div slot="footer">
          <Button type="warning" size="large" long @click="codeFn">确定</Button>
        </div> -->
      </Modal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getLocalStorageItem, setLocalStorageItem } from '@/utils'// isPhoneNo
import { api } from '@/services'
import config from '@/config'
import VueQr from 'vue-qr'

const loginModelCache = JSON.parse(
  getLocalStorageItem(config.storage.authInfoCacheKey) || '{}'
)

export default {
  name: 'Login',
  components: { VueQr },
  data () {
    const reg = /^1[3-9]\d{9}$/

    const validateMobile = (rule, val, cb) => {
      if (!val) {
        cb(new Error('账号不能为空'))
      } else if (!reg.test(val)) {
        cb(new Error('手机号格式不正确'))
      } else {
        cb()
      }
    }
    const dangerousReg = /<script|on\w+=|javascript:|eval|alert|document\.cookie/i
    const validateContent = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空'))
      } else if (dangerousReg.test(value)) {
        callback(new Error('输入内容包含危险字符，请重新输入'))
      } else {
        callback()
      }
    }
    return {
      TIME: new Date().getTime(), // 获取现在时间戳
      CAcode: '', // CA自动签二维码对话框
      text: '证书过期请使用APP扫描二维码激活', // CA证书二维码对话标题
      judge: true, // 判断是否没有登陆app直接登录pc无证书的情况
      doctorCaCert: '', // 登录接口返回证书字段
      Token: '', // 保存token
      caUserId: '', // caUserId登录接口返回
      caType: '',
      codeQr: '', // CA证书二维码
      modalCAcode: false, // CA自动签二维码对话框
      modalcode: false, // CA证书二维码对话框

      modalSelectHospital: false,
      selectHospital: {
        hospitalList: [],
        hospitalGuid: ''
      },
      loginModel: {
        // mobile: loginModelCache.mobile || '18612032816',
        // password: '123456'
        src: 'doctor',
        mobile: loginModelCache.mobile || '',
        password: ''
      },
      rules: {
        mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        password: [{ required: true, validator: validateContent, message: '', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      loginLoading: 'auth/loading',
      accessedRoutes: 'power/accessedRoutes',
      info: 'auth/info'
    })
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      generateRoutes: 'power/generateRoutes'
    }),
    okSelectHospital () {
      setLocalStorageItem(config.storage.authTokenKey + '-hospitalGuid', this.selectHospital.hospitalGuid)
      this.handleSubmit()
    },
    cancelSelectHospital () {
      console.log('关闭')
    },
    // 证书验证
    doctorCertValidation (caUserId, hospitalGuid) {
      let data = api.doctorCertValidation({
        data: {
          token: this.Token,
          params: {
            caUserId,
            cert: this.doctorCaCert,
            hospitalGuid: hospitalGuid
          }
        }
      })
      return data
    },
    // CA自动签二维码
    doctorCertAutoSign (caUserId, hospitalGuid) {
      // 删除token
      localStorage.removeItem('TG_SERVER_TOKEN')
      api.doctorCertAutoSign({
        data: {
          token: this.Token,
          params: {
            caUserId,
            hospitalGuid
          }
        }
      }).then(res => {
        if (res.code === 0) {
          this.modalCAcode = true
          this.CAcode = res.data.authCode
          var AutoFilter = setInterval(() => {
            this.getDoctorAutoSignResult(caUserId).then(item => {
              if (item.code === 0 && item.data.type == 1 && this.TIME - item.data.expirationTime < 300000) {
                this.handleSubmit()
                clearInterval(AutoFilter)
              }
            })
          }, 3000)
        }
      })
    },
    doctorCertAutoSignYiWangXin (caUserId, hospitalGuid) {
      localStorage.removeItem('TG_SERVER_TOKEN')
      let _params = {
        caUserId
      }
      if (hospitalGuid) {
        _params.hospitalGuid = hospitalGuid
      }
      this.getDoctorAutoSignResult(caUserId).then(item => {
        if (this.caType === 'yiWangXinCaClient' && item.code === 0 && item.data.data.grantStep == 1) {
          // this.handleSubmit()
          this.$store.dispatch('auth/loginSuccess', this.Token)
          const query = this.$route.query
          this.$router.replace({
            name: 'PrivateConsultationPage',
            params: JSON.parse(query.redirect_params || '{}'),
            query: JSON.parse(query.redirect_query || '{}')
          })
        } else {
          api.doctorCertAutoSign({
            data: {
              token: this.Token,
              params: _params
            }
          }).then(res => {
            if (res.code === 0) {
              if (res.data.data) {
                this.modalCAcode = true
                this.CAcode = ('data:image/png;base64,' + res.data.data)
              }
              this.$Message.info(res.data.message)
              var AutoFilter = setInterval(() => {
                this.getDoctorAutoSignResult(caUserId).then(item => {
                  if (item.code === 0 && item.data.type == 1 && this.TIME - item.data.expirationTime < 300000) {
                    this.handleSubmit()
                    clearInterval(AutoFilter)
                  }
                  if ((this.caType === 'yiWangXinCaClient' && item.code === 0 && item.data.data.grantStep == 1) || (this.caType == 'yiWangXinInternetCaClient' && item.code === 0 && item.data.data == true)) {
                    // this.handleSubmit()
                    this.$store.dispatch('auth/loginSuccess', this.Token)
                    const query = this.$route.query
                    this.$router.replace({
                      name: 'PrivateConsultationPage',
                      params: JSON.parse(query.redirect_params || '{}'),
                      query: JSON.parse(query.redirect_query || '{}')
                    })
                    clearInterval(AutoFilter)
                  }
                })
              }, 3000)
            }
          })
        }
      })
    },
    // 判断是否完成自动签
    getDoctorAutoSignResult (caUserId) {
      let data = api.getDoctorAutoSignResult({
        data: {
          token: this.Token,
          params: { caUserId }
        }
      })
      return data
    },
    // 获取CA证书下载二维码
    doctorCertActivationCode (type, hospitalGuid) {
      // 删除token
      localStorage.removeItem('TG_SERVER_TOKEN')
      api.doctorCertActivationCode({
        data: {
          token: this.Token,
          params: {
            hospitalGuid: hospitalGuid
          }
        }
      }).then(res => {
        if (!type) {
          var setInter = setInterval(() => {
            this.doctorCertValidation(this.caUserId).then(item => {
              if (item.code === 0) {
                clearInterval(setInter)
                // this.modalcode = false
                this.handleSubmit()
              }
            })
          }, 3000)
        }
        if (res.code === 0) {
          this.codeQr = res.data.authCode
          this.modalcode = true
        }
      })
    },
    // 关闭遮罩层
    codeFn () {
      this.modalcode = false
    },
    handleSubmit () {
      console.log(111111)
      this.$refs.loginForm.validate(valid => {
        console.log(333)
        if (valid) {
          this.login(this.loginModel).then(success => {
            if (success) {
              if (success.needCert === '0' && success.caUserId) {
                this.doctorCaCert = success.doctorCaCert
                this.caUserId = success.caUserId
                this.Token = success.token
                this.caType = success.caType
                if (success.doctorCaCert === null || success.doctorCaCert === undefined || success.doctorCaCert === '') {
                  // this.$Message.warning({
                  //   background: true,
                  //   content: '首次登录客户端请在APP上下载证书'
                  // })
                  this.text = '首次登录请在APP上扫码下载证书'
                  this.judge = false
                  if (this.caType === 'yiWangXinCaClient' || this.caType == 'yiWangXinInternetCaClient') {
                    this.doctorCertAutoSignYiWangXin(success.caUserId, success.hospital_guid)
                  } else {
                    this.doctorCertActivationCode(1, success.hospital_guid)
                  }
                  return false
                }
                this.text = '证书过期请使用APP扫描二维码激活'
                this.judge = true
                // 判断证书是否过期
                this.doctorCertValidation(success.caUserId, success.hospital_guid).then(res => {
                  // localStorage.setItem('TG_SERVER_TOKEN_caUserId', success.caUserId)
                  if (res.code === 0) {
                    this.getDoctorAutoSignResult(success.caUserId).then(item => {
                      if (item.code === 0 && item.data.type == 1 && this.TIME - item.data.expirationTime < 300000) {
                        if (success.hospitalList && success.hospitalList.length > 1) {
                          this.modalSelectHospital = true
                          this.selectHospital.hospitalList = success.hospitalList
                          return false
                        }
                        const query = this.$route.query
                        // console.log(query);
                        this.$router.replace({
                          // name: query.redirect_uri_name || "Home",
                          name: 'PrivateConsultationPage',
                          params: JSON.parse(query.redirect_params || '{}'),
                          query: JSON.parse(query.redirect_query || '{}')
                        })
                      } else {
                        this.doctorCertAutoSign(success.caUserId, success.hospital_guid)
                      }
                    })
                  } else {
                    this.doctorCertActivationCode(0, success.hospital_guid)
                  }
                })
                return false
              }
              // localStorage.removeItem('TG_SERVER_TOKEN_caUserId')
              // 正常逻辑
              if (success.hospitalList && success.hospitalList.length > 1) {
                this.modalSelectHospital = true
                this.selectHospital.hospitalList = success.hospitalList
                return false
              }
              const query = this.$route.query
              // console.log(query);
              this.$router.replace({
                // name: query.redirect_uri_name || "Home",
                name: 'PrivateConsultationPage',
                params: JSON.parse(query.redirect_params || '{}'),
                query: JSON.parse(query.redirect_query || '{}')
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/vars/index';
@import '~@/assets/stylus/mixins/index';

.login {
  full();
  background: url('/static/image/login-background1.jpg') no-repeat top left;
  background-size: cover;

  &-word {
    position: absolute;
    left: 45%;
    top: 20%;
    transform: translateY(-35%);
    transform: translateX(-22%);
    width: 400px;
    // background url('/static/image/login-word.png') no-repeat top left 100%
    // background-size cover
  }

  &-con {
    position: absolute;
    // right 160px
    left: 50%;
    top: 30%;
    transform: translateY(-40%);
    transform: translateX(-40%);
    width: 300px;

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      padding: 10px 0 0;
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }
  }

  +mobile-tablet() {
    &-con {
      right: auto;
      left: 50%;
      transform: translate(-50%, -20%);
    }

    &-word {
      right: auto;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/index.vue